import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import commonZhHK from './locales/zh-HK/common.json';
import navigationZhHK from './locales/zh-HK/navigation.json';
import heroZhHK from './locales/zh-HK/hero.json';
import aboutZhHK from './locales/zh-HK/about.json';
import contactZhHK from './locales/zh-HK/contact.json';
import footerZhHK from './locales/zh-HK/footer.json';
import floatingZhHK from './locales/zh-HK/floating.json';
import wechatZhHK from './locales/zh-HK/wechat.json';
import newsCommonZhHK from './locales/zh-HK/news/common.json';
import news202608ZhHK from './locales/zh-HK/news/2026-08.json';
import news202510ZhHK from './locales/zh-HK/news/2025-10.json';

import commonEn from './locales/en/common.json';
import navigationEn from './locales/en/navigation.json';
import heroEn from './locales/en/hero.json';
import aboutEn from './locales/en/about.json';
import contactEn from './locales/en/contact.json';
import footerEn from './locales/en/footer.json';
import floatingEn from './locales/en/floating.json';
import wechatEn from './locales/en/wechat.json';
import newsCommonEn from './locales/en/news/common.json';
import news202608En from './locales/en/news/2026-08.json';
import news202510En from './locales/en/news/2025-10.json';

// Translation resources
const resources = {
  'zh-HK': {
    common: commonZhHK,
    navigation: navigationZhHK,
    hero: heroZhHK,
    about: aboutZhHK,
    contact: contactZhHK,
    footer: footerZhHK,
    floating: floatingZhHK,
    wechat: wechatZhHK,
    news: {
      sectionTitle: newsCommonZhHK.sectionTitle,
      events: [news202608ZhHK, news202510ZhHK],
    },
  },
  en: {
    common: commonEn,
    navigation: navigationEn,
    hero: heroEn,
    about: aboutEn,
    contact: contactEn,
    footer: footerEn,
    floating: floatingEn,
    wechat: wechatEn,
    news: {
      sectionTitle: newsCommonEn.sectionTitle,
      events: [news202608En, news202510En],
    },
  },
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    resources,
    fallbackLng: 'zh-HK',
    defaultNS: 'common',
    debug: false,

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
